export default __webpack_public_path__ + "static/BIG_jerry_fencing-27abcde50053b76247392929ee80ad7e.png";